export const productType = {
  JOBPOSTING: 'job_posting',
  FEATUREDEMPLOYER: 'featured_employer',
  CREDIT: 'credit',
  CUSTOM: 'custom',
  CONTRACT: 'contract',
  SLOT: 'slot',
  JOB_UP_SELL: 'job_up_sell',
  RECRUITER_SEAT: 'recruiter_seat',
}
